import { AssetType, Template } from '@amzn/fire-tv-campaign-automation-service';

interface AssetConfig {
  acceptedFileTypes: string;
  allowedContentTypes: string[];
  assetKeyPrefix: string;
  dataTestId: string;
  displayLabel: string;
  expectedAspectRatio?: number;
  fileName: string;
  maxDurationInSeconds?: number;
  maxFileSizeInBytes: number;
  minDurationInSeconds?: number;
  minResolution: {
    height: number;
    width: number;
  };
  maxResolution: {
    height: number;
    width: number;
  };
}

export const ASSET_CONFIG: Record<AssetType, AssetConfig> = {
  [AssetType.BACKGROUND_IMAGE]: {
    allowedContentTypes: ['image/jpeg'],
    dataTestId: 'asset-input-background-image',
    displayLabel: 'Background Image',
    //   expectedAspectRatio: 16 / 9,
    maxFileSizeInBytes: 450 * 1024,
    minResolution: {
      width: 1920,
      height: 720,
    },
    maxResolution: {
      width: 1920,
      height: 720,
    },
    assetKeyPrefix: 'bgd_images',
    fileName: 'bgd_image',
    acceptedFileTypes: '.jpeg,.jpg',
  },
  [AssetType.LOGO]: {
    allowedContentTypes: ['image/png'],
    dataTestId: 'asset-input-logo',
    displayLabel: 'Logo',
    //  expectedAspectRatio: 32 / 13, // Approximately 2.46:1
    maxFileSizeInBytes: 450 * 1024,
    minResolution: {
      width: 640,
      height: 260,
    },
    maxResolution: {
      width: 640,
      height: 260,
    },
    assetKeyPrefix: 'logo_images',
    fileName: 'logo',
    acceptedFileTypes: '.png',
  },
  [AssetType.VIDEO_TRAILER]: {
    allowedContentTypes: ['video/mp4', 'video/quicktime', 'video/mpeg'],
    dataTestId: 'asset-input-video-trailer',
    displayLabel: 'Video Trailer',
    //expectedAspectRatio: 16 / 9,
    maxFileSizeInBytes: 500 * 1024 * 1024,
    minResolution: {
      width: 1920,
      height: 1080,
    },
    maxResolution: {
      width: 1920,
      height: 1080,
    },
    assetKeyPrefix: 'video_trailers',
    fileName: 'video_trailer',
    acceptedFileTypes: '.mp4,.mov,.mpeg',
    minDurationInSeconds: 5,
    maxDurationInSeconds: 21,
  },
};

export const TEMPLATE_TO_REQUIRED_ASSETS_CONFIG: Record<Template, AssetType[]> = {
  [Template.FR_READY_ASSETS]: [AssetType.BACKGROUND_IMAGE, AssetType.LOGO, AssetType.VIDEO_TRAILER],
};
